import React from 'react'
import wind from "../vectors/services_icons/wind.svg"
import ventilation from "../vectors/services_icons/ventilation.svg"
import sun_path from "../vectors/services_icons/sun_path.svg"
import hvac from "../vectors/services_icons/hvac.svg"
import heating from "../vectors/services_icons/haeting.svg"
import facade from "../vectors/services_icons/facade2.svg"
import comfort from "../vectors/services_icons/comfort2.svg"
import ahu from "../vectors/services_icons/ahu2.svg"

export default function servicesPage() {
  return (
    <div className='services-container'>

      <h1>Szolgáltatásaink:</h1>

      <div className='services-grid-container'>

          <section>
          <img src={sun_path} alt="sun_path" />
          </section>

          <section>
          <h2>Egészéves/évszakos dinamikus szimuláció </h2>
          <p>
            Az egész éves és évszakos dinamikus szimuláció a környezettudatos és energiahatékony tervezés alapja. Segítségével már az építés vagy felújítás tervezési fázisában pontosan előrejelezhetőek az épület működési költségei. Valós időjárási adatok alapján az év minden órájára meghatároz szimulációs eredményt tájolás és épületszerkezet figyelembe vételével. Erdeményei között megtalálhatóak hőkomfort paraméterek, páratartalom és a belső természetes fényviszonyok.
            </p>
          </section>

          <section>
          <img src={heating} alt="heating" />
          </section>


          <section>
          <h2>Hőleadók méretezése </h2>
          <p>
          A hőleadók méretezésének célja a helységenkénti hűtő/fűtő rendszerek típusainak és teljesítményeinek meghatározása a hőkomfort és az energiahatékonyság figyelmebevételével. A dinamikus szimuláció részeként már a tervezés folyamán kimutathatók az várható üzemeltetési költségek, minimalizálva a túlméretezést.
          </p>
          </section>


          <section>
          <img src={hvac} alt="heating" />
          </section>

          <section>
          <h2>Hőleadók ellenőrzése </h2>
            <p>A hőleadók ellenőrzése során a megépített vagy tervezés alatt álló épületet lehet ellenőrizni dinamikus szimulációval, így lehetővé válik a 
            eltérő megfontolással vagy más, kevésbé szofisztikált programcsomaggal méretezett fűtési és hűtési rendszerek ellenőrzése. Segítségével kimutathatók a
            túlméretezések, az üzemeltetési többlet költségek, a helyiségekben kialakuló pára és komfort problémák. A feltárással egyidejűleg megoldást lehet keresni az üzemeltetési költésgek csökkentésére és az üzemeltetés során jelentkező panaszok megszüntetésére. 
             </p>
          </section>


          <section>
          <img src={facade} alt="heating" />
          </section>

          
          <section>
          <h2>Homlokzat optimálása </h2>
          <p>Egy ingatlan energiahatékonyságát és belső komfortját a homlokzat és az épületszerkezet határozza meg. A homlokzat optimalizálása során meghatározhatók az épületspecifikus és tájolásfüggő adatai, üvegezési arány valamint az üvegezés típusa. </p>
          </section>
          

          <section>
          <img src={ventilation} alt="heating" />
          </section>

          <section>
          <h2>Épület szellőzés szimuláció </h2>
          <p>A CFD (áramlástani) épületszellőzési szimuláció a modern mérnöki tervezés csúcstechnológiája, amely láthatóvá teszi a láthatatlant: a levegő pontos mozgását. A digitális 3D modellezés során tűpontosan feltérképezzük a légáramlási útvonalakat, a sebességet, a hőmérsékleti rétegződést és a légcsere hatékonyságát a belső terekben. Ez az eljárás kulcsfontosságú a huzatmentes, egészséges beltéri klíma megteremtéséhez, valamint a CO2 és az egyéb szennyeződések gyors eltávolításához. A szimuláció segítségével már a kivitelezés előtt optimalizálhatók a szellőzőrendszerek és a természetes átszellőztetés útvonalai. Ezzel elkerülhetők a holtterek, minimalizálható a ventilátorok energiafogyasztása, és garantálható a maximális frisslevegő-ellátás a legalacsonyabb üzemeltetési költségek mellett.</p>
          </section>


          <section>
          <img src={wind} alt="heating" />
          </section>

          <section>
          <h2>Gyalogos CFD komfort vizsgálata </h2>
          <p>A CFD gyalogoskomfort-vizsgálat az aerodinamikai tervezés kulcsfontosságú eszköze, amellyel az épületek körüli szélviszonyokat modellezzük. A digitális szimuláció pontosan kimutatja, hogyan változtatják meg az új beépítések és a nagy magasságú épületek a talajszinti légáramlatokat. A kiértékelés során a nemzetközileg elismert Lawson-szélkritérium alapján osztályozzuk a közterületeket a szélsebesség és a statisztikai előfordulás tükrében. Ez a módszer garantálja, hogy a kávézóteraszok, parkok és járdák biztonságosak, huzatmentesek és kellemesek maradjanak a gyalogosok számára. A szimuláció segítségével már a tervezőasztalon optimalizálhatók az épületformák, valamint a védelmet nyújtó fasorok és paravánok elhelyezése.</p>
          </section>

          <section>
          <img src={comfort} alt="heating" />
          </section>

          <section>
          <h2>Hőkomfort CFD vizsgálata </h2>
          <p>A hőkomfort CFD vizsgálata a belső terek tökéletes hőérzetének tudományos megalapozása. Ez a fejlett áramlástani szimuláció részletesen modellezi a levegő hőmérsékletét, sebességét, a páratartalmat, valamint a falak sugárzási hőjét az épület minden pontján. Segítségével mérnöki pontossággal előrejelezhető, hogy a jövőbeli használók hogyan élik meg a belső klímát a különböző évszakokban. A vizsgálat kiküszöböli a kellemetlen huzathatást, a hideg vagy túlmelegedő zónákat, miközben optimalizálja a fűtő- és hűtőrendszerek működését. A technológia biztosítja, hogy az irodák, lakások vagy közösségi terek ne csupán energiahatékonyak, hanem maximálisan kényelmesek és egészségesek legyenek.</p>
          </section>

          <section>
          <img src={ahu} alt="heating" />
          </section>


          <section>
          <h2>AHU optimalizálása </h2>
          <p>A dinamikus épületszimulációban lehetőség van légkezelőt modellezni, mellyel le lehet ellenőrizni egy már meglévő LK működését vagy egy felújítás/újépítés esetén optimalizálni lehet az épület sajátosságainak figyelembevételével. Az optimalizálás hatásait nyomon lehet követni az épület helyiségeiben.
            
          </p>
          </section>

      </div>

    </div>
  )
}
